var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLangFull = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 150 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M20.966 20.478a2.424 2.424 0 0 0 2.423-2.426 2.424 2.424 0 1 0-4.846 0 2.424 2.424 0 0 0 2.423 2.425"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M20.968 14.158a2.03 2.03 0 1 0-.002-4.06 2.03 2.03 0 0 0 .002 4.06"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M10.767 20.138a2.03 2.03 0 1 0-.002-4.06 2.03 2.03 0 0 0 .002 4.06"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M10.767 31.929a2.03 2.03 0 1 0-.002-4.06 2.03 2.03 0 0 0 .002 4.06"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M20.968 37.848a2.03 2.03 0 1 0-.002-4.06 2.03 2.03 0 0 0 .002 4.06"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M31.168 31.929a2.03 2.03 0 1 0-.002-4.06 2.03 2.03 0 0 0 .002 4.06"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M31.168 20.138a2.03 2.03 0 1 0-.002-4.06 2.03 2.03 0 0 0 .002 4.06"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M31.617 13.652a1.635 1.635 0 1 0-.001-3.27 1.635 1.635 0 0 0 .001 3.27"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M31.617 37.566a1.635 1.635 0 1 0-.001-3.27 1.635 1.635 0 0 0 .001 3.27"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M10.373 13.652a1.635 1.635 0 1 0-.002-3.27 1.635 1.635 0 0 0 .002 3.27"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M10.373 37.566a1.635 1.635 0 1 0-.001-3.27 1.635 1.635 0 0 0 0 3.27"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M36.578 22.396a1.635 1.635 0 1 0-.001-3.27 1.635 1.635 0 0 0 0 3.27"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M5.353 22.395a1.635 1.635 0 1 0-.001-3.27 1.635 1.635 0 0 0 .001 3.27"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M5.353 28.823a1.635 1.635 0 1 0-.001-3.27 1.635 1.635 0 0 0 .001 3.27"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M36.638 28.823a1.635 1.635 0 1 0 0-3.27 1.635 1.635 0 0 0 0 3.27"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M26.043 10.378a1.635 1.635 0 1 0-.001-3.27 1.635 1.635 0 0 0 0 3.27"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M26.043 40.84a1.635 1.635 0 1 0-.001-3.27 1.635 1.635 0 0 0 0 3.27"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M15.894 10.378a1.635 1.635 0 1 0-.001-3.27 1.635 1.635 0 0 0 .001 3.27"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M15.894 40.84a1.635 1.635 0 1 0 0-3.27 1.635 1.635 0 0 0 0 3.27"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M20.965 48.003a1.24 1.24 0 1 0 0-2.482 1.24 1.24 0 0 0 0 2.482"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M25.701 45.407a1.24 1.24 0 1 0 0-2.482 1.24 1.24 0 0 0 0 2.482"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M16.29 45.407a1.24 1.24 0 1 0-.002-2.481 1.24 1.24 0 0 0 .001 2.48"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M16.29 5.078a1.24 1.24 0 1 0-.002-2.481 1.24 1.24 0 0 0 .001 2.481"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M25.645 5.021a1.24 1.24 0 1 0-.001-2.48 1.24 1.24 0 0 0 0 2.48"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M20.965 2.482a1.24 1.24 0 1 0 0-2.481 1.24 1.24 0 0 0 0 2.48"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M36.072 39.316a1.24 1.24 0 1 0 0-2.481 1.24 1.24 0 0 0 0 2.48"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M5.92 39.316a1.24 1.24 0 1 0 0-2.481 1.24 1.24 0 0 0 0 2.48"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M5.92 11.112a1.24 1.24 0 1 0 0-2.482 1.24 1.24 0 0 0 0 2.481"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M36.072 11.112a1.24 1.24 0 1 0 0-2.482 1.24 1.24 0 0 0 0 2.481"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M40.637 36.553a1.24 1.24 0 1 0 0-2.481 1.24 1.24 0 0 0 0 2.48"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M40.637 31.251a1.24 1.24 0 1 0 0-2.481 1.24 1.24 0 0 0 0 2.481"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M40.693 19.237a1.24 1.24 0 1 0 0-2.481 1.24 1.24 0 0 0 0 2.48"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M40.637 13.875a1.24 1.24 0 1 0 0-2.482 1.24 1.24 0 0 0 0 2.482"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M1.352 36.553a1.24 1.24 0 1 0-.001-2.481 1.24 1.24 0 0 0 0 2.48"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M1.24 31.251a1.24 1.24 0 1 0 0-2.481 1.24 1.24 0 0 0 0 2.481"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M1.297 19.237a1.24 1.24 0 1 0 0-2.481 1.24 1.24 0 0 0 0 2.48"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M1.352 13.875a1.24 1.24 0 1 0-.001-2.481 1.24 1.24 0 0 0 0 2.48"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M20.966 32.32a2.424 2.424 0 0 0 2.423-2.425 2.424 2.424 0 0 0-2.423-2.425 2.424 2.424 0 0 0-2.423 2.425 2.424 2.424 0 0 0 2.423 2.426"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M26.097 29.387a2.424 2.424 0 0 0 2.423-2.426 2.424 2.424 0 0 0-2.423-2.425 2.424 2.424 0 0 0-2.423 2.425 2.424 2.424 0 0 0 2.423 2.426"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M26.097 23.41a2.424 2.424 0 0 0 2.423-2.425 2.424 2.424 0 0 0-2.423-2.426 2.424 2.424 0 0 0-2.423 2.426 2.424 2.424 0 0 0 2.423 2.425"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M15.837 29.387a2.424 2.424 0 0 0 2.423-2.426 2.424 2.424 0 1 0-2.423 2.426"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M15.837 23.41a2.424 2.424 0 0 0 2.423-2.425 2.424 2.424 0 1 0-4.846 0 2.424 2.424 0 0 0 2.423 2.425"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M132.761 32.139V14.193h3.335v17.946z"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "m114.857 32.139 6.895-17.946h3.435l6.894 17.946h-3.584l-1.493-4.033h-7.144l-1.493 4.033zm6.048-6.895h5.028l-2.514-6.82z"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M111.139 28.803h3.484v3.336h-3.484z"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M103.43 36.992c-3.51 0-5.874-1.593-6.272-4.604h3.161c.174 1.294 1.319 2.09 3.111 2.09 1.942 0 3.136-1.07 3.136-2.862v-1.618c-.622.871-1.991 1.493-3.609 1.493-3.733 0-6.048-2.514-6.048-6.222 0-3.734 2.315-6.247 5.974-6.247 1.568 0 2.937.647 3.683 1.617v-1.418h3.136v12.071c0 3.535-2.439 5.7-6.272 5.7m0-8.189c2.016 0 3.311-1.394 3.311-3.534 0-2.116-1.295-3.534-3.311-3.534s-3.335 1.393-3.335 3.534 1.319 3.534 3.335 3.534"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M83.992 32.139V19.22h3.136v1.99c.846-1.318 2.315-2.19 4.132-2.19 2.787 0 4.68 1.842 4.68 4.655v8.463h-3.112v-7.741c0-1.519-.97-2.589-2.49-2.589-2.04 0-3.21 1.742-3.21 4.655v5.675z"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M75.355 32.338c-2.614 0-4.505-1.568-4.505-3.734 0-2.265 1.642-3.659 4.505-4.032l2.588-.348c.697-.1 1.046-.448 1.046-1.021 0-.946-.921-1.742-2.44-1.742-1.418 0-2.489.746-2.588 2.066h-3.037c.299-2.763 2.39-4.506 5.625-4.506 3.41 0 5.576 1.942 5.576 5.003v4.555c0 .722.274 1.046.796 1.046.174 0 .423-.05.423-.05v2.564s-.746.149-1.493.149c-1.32 0-2.29-.622-2.44-1.842-.572 1.145-2.14 1.892-4.056 1.892m.522-2.39c2.017 0 3.186-1.443 3.186-3.385v-.373l-3.186.522c-1.269.2-1.891.797-1.891 1.743 0 .871.746 1.493 1.891 1.493"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2D26",
  d: "M59.276 32.139V14.193h3.335v14.984h8.413v2.962z"
})));
export { SvgLangFull as ReactComponent };
export default __webpack_public_path__ + "static/langFull.1a4537a4.svg";